import styled from 'styled-components';

export const CreatedAccountStyled = styled.div`
    border: 1px solid var(--color-yellow);
    padding: 0 24px 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
`;

export const CreatedAccountWrapperStyled = styled.div`
    padding: 8px;
    background: var(--color-surface);
    position: relative;
    top: -32px;
`;

export const CreatedAccountIconStyled = styled.div`
    display: inline-block;
    padding: 4px;
    background: var(--color-yellow);
    border-radius: 8px;
`;
